import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Megaphone, CreditCard } from 'lucide-react';
import { postsAPI } from '../api';

const Announcements = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    try {
      const [blogRes, annRes] = await Promise.all([
        postsAPI.getAll('news', 6, true),
        postsAPI.getAll('announcements', 6, true)
      ]);
      const combined = [...(blogRes.data || []), ...(annRes.data || [])]
        .filter(p => p.published)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .slice(0, 12);
      setItems(combined);
    } catch (error) {
      console.error('Error loading sponsors updates:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || items.length === 0) return null;

  return (
    <section className="py-20 bg-[var(--ink)]" data-testid="sponsors-updates-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 bg-[var(--madder)]/15 rounded-full">
            <Megaphone className="text-[var(--madder)]" size={20} />
            <span className="text-[var(--madder)] font-medium">Latest Updates</span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl font-medium tracking-tight text-white mb-4" data-testid="sponsors-updates-heading">
            Sponsors <span className="text-[var(--madder)]">Updates</span>
          </h2>
          <p className="text-gray-400 text-lg">
            Stay informed with the latest news and updates from Paisley
          </p>
          <Link
            to="/sponsors"
            className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 bg-[var(--madder)] hover:bg-[var(--madder-deep)] text-white text-sm font-medium rounded-lg transition-colors"
            data-testid="become-sponsor-btn"
          >
            <CreditCard size={16} />
            Become a Sponsor
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {items.map((item) => (
            <Link 
              key={item.id} 
              to={`/news/${item.slug}`}
              className="group"
              data-testid={`sponsor-card-${item.slug}`}
            >
              <div className="bg-slate-800 rounded-lg overflow-hidden border border-slate-700 hover:border-[var(--madder)] transition-all duration-300 h-full">
                <div className="relative overflow-hidden h-24">
                  <img 
                    src={item.featured_image} 
                    alt={item.title} 
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    onError={(e) => { e.target.src = '/api/files/paisley-org/wp-content/uploads/2025/09/Paisley-skyline-from-abbey-770x513-1.jpg'; }}
                  />
                  <div className="absolute top-1.5 left-1.5">
                    <span className="px-1.5 py-0.5 bg-[var(--madder)] text-white text-[10px] font-semibold rounded-full capitalize">
                      {item.category === 'announcements' ? 'Sponsor' : 'Blog'}
                    </span>
                  </div>
                </div>
                <div className="p-2.5">
                  <div className="flex items-center gap-1 text-[10px] text-gray-400 mb-1">
                    <Calendar size={10} />
                    <span>{new Date(item.created_at).toLocaleDateString()}</span>
                  </div>
                  <h3 className="text-xs font-bold text-white group-hover:text-[var(--madder)] transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Announcements;
